import { useAtom, useAtomValue } from 'jotai';
import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import * as state from '../state';
import { useCallback, useMemo } from 'react';
import { transformModeToString } from '../util/util';
import { AXES, AXES_NAMES } from '../constants';

export const AxesSelector = () => {
  const transformMode = useAtomValue(state.transformMode);
  const [activeAxes, setActiveAxes] = useAtom(state.activeAxes);

  const mode = useMemo(() => transformModeToString(transformMode), [transformMode]);

  const isAxisEnabled = useCallback(
    (index: number) => mode && activeAxes[mode].includes(AXES[index]),
    [mode, activeAxes]
  );

  const toggleAxis = useCallback(
    (index: number) => {
      if (!mode) return;
      setActiveAxes((current) => {
        const oldActiveAxes = current[mode];
        // eslint-disable-next-line no-console
        console.log('oldActiveAxes', oldActiveAxes);
        const oldIndex = oldActiveAxes.search(AXES[index]);
        if (oldIndex >= 0) {
          return {
            ...current,
            [mode]: oldActiveAxes.replace(AXES[index], ''),
          };
        } else {
          return {
            ...current,
            [mode]: oldActiveAxes + AXES[index],
          };
        }
      });
    },
    [mode, setActiveAxes]
  );

  return (
    mode && (
      <Stack>
        <Typography>Active axes</Typography>
        <Stack sx={{ overflowY: 'auto' }} direction="row">
          {AXES_NAMES[mode ?? 'translate'].map((value, index) => (
            <Box sx={{ paddingY: 0.5 }} key={index}>
              <FormControlLabel
                disabled={!mode}
                control={
                  <Switch
                    checked={isAxisEnabled(index) ?? false}
                    onChange={() => toggleAxis(index)}
                    size="small"
                  />
                }
                label={value}
                labelPlacement="start"
              />
            </Box>
          ))}
        </Stack>
      </Stack>
    )
  );
};
